import React from 'react';
import '../../components/css/popupstyle.css';
import { userService } from '../../_services';
import DeleteIcon from '../../components/css/dark/img/delete.svg';
import EditIcon from '../../components/css/dark/img/edit2.svg';
import $ from 'jquery';

class dynamicCommission extends React.Component {
    constructor(props) {
        super(props);
        let selectedBin;
        let TierData;
        if (this.props.dynamicData!=undefined && this.props.dynamicData[0].isDynamic == true && this.props.dynamicData[0].tierJson != '') {
            selectedBin = this.props.dynamicData[0].tierJson[0].Bin;
            TierData = this.props.dynamicData[0].tierJson[0].Tier;
        } else {
            // eslint-disable-next-line no-unused-expressions
            selectedBin = null,
            TierData = []
        }
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            error: '',
            btnLoader: false,
            binData: [],
            loader: false,
            tierMilestone: TierData,
            selectedBin: selectedBin,
            tierDetail:[]
        }
        this.bin = React.createRef();
    }
    componentDidMount() {
        this.getBinTier(parseInt(this.props.whId));
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    handleCancel = () => {
        try {
            this.props.closeDynamicPopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch);
            this.props.openEditProfilePopup(this.props.whName, this.props.whId, this.props.whPrefix, this.props.whProfilePagin, this.props.whSearch, this.props.dynamicData[0].isDynamic);
        }
        catch (error) {}
    }
    handleSaveSubmit = (e) => {
        try {
            // disable submit
            this.setState({ btnLoader: true });
            $(e.target).attr("disabled", true);
            $('.cancel').attr("disabled", true);
            $('.close-btn').attr("disabled", true);            

            // get input field values
            let whid = this.props.whId;
            let BIN = this.bin.current.value;

            let tier = [];
            let Tier_Name_List = this.state.tierDetail;
            $('.dynamic .milestoneData').each(function (index, data) {
                let id = parseInt(data.firstChild.textContent);
                let tierName = Tier_Name_List[index].tierName;
                let tierId = parseInt(Tier_Name_List[index].tierId);
                let from = data.querySelector('.second-one input').value;
                let to = data.querySelector('.third-one input').value;
                let commission = data.querySelector('.fourth-one input').value;
                tier.push({ msid: id, tierId: tierId, tierName: tierName, from: from, to: to, commission: commission })
            });
            let tierJson = [{ BIN: BIN, Tier: tier }];
            let IsdynamicError = 0;

            if (parseInt(tier[0].from) == 0 || parseInt(tier[0].from) < 0) {
                let dynamicJsonLength = parseInt(tier.length) - 1;
                for (let i = 0; i < tier.length; i++) {
                    $('input').removeClass('focus');
                    var floatRegex = /^[-+]?[0-9]+\.[0-9]+$/;
                    if (tier[i].from === "") {
                        IsdynamicError = 2;
                        $('input[name="dynamicFrom"]').eq(i).focus();
                        $('input[name="dynamicFrom"]').eq(i).addClass('focus');
                        break;
                    } else if (floatRegex.test(tier[i].from)) {
                        IsdynamicError = 3;
                        $('input[name="dynamicFrom"]').eq(i).focus();
                        $('input[name="dynamicFrom"]').eq(i).addClass('focus');
                        break;
                    } else if (tier[i].to === "") {
                        IsdynamicError = 4;
                        $('input[name="dynamicTo"]').eq(i).focus();
                        $('input[name="dynamicTo"]').eq(i).addClass('focus');
                        break;
                    } else if (floatRegex.test(tier[i].to)) {
                        IsdynamicError = 3;
                        $('input[name="dynamicTo"]').eq(i).focus();
                        $('input[name="dynamicTo"]').eq(i).addClass('focus');
                        break;
                    } else if (!(parseInt(tier[i].to) > parseInt(tier[i].from))) {
                        IsdynamicError = 5;
                        $('input[name="dynamicTo"]').eq(i).focus();
                        $('input[name="dynamicTo"]').eq(i).addClass('focus');
                        break;
                    } else if (tier[i].commission === "") {
                        IsdynamicError = 6;
                        $('input[name="dynamicComm"]').eq(i).focus();
                        $('input[name="dynamicComm"]').eq(i).addClass('focus');
                        break;
                    } else if (parseInt(tier[i].commission) > 10) {
                        IsdynamicError = 7;
                        $('input[name="dynamicComm"]').eq(i).focus();
                        $('input[name="dynamicComm"]').eq(i).addClass('focus');
                        break;
                    } else if (i == tier.length - 1) {
                        if (parseInt(tier[dynamicJsonLength].to) != 999999) {
                            IsdynamicError = 8;
                            $('input[name="dynamicTo"]').eq(i).focus();
                            $('input[name="dynamicTo"]').eq(i).addClass('focus');
                            break;
                        } else {
                            if (parseInt(tier[i].from) != (parseInt(tier[i - 1].to) + 1)) {
                                IsdynamicError = 9;
                                $('input[name="dynamicFrom"]').eq(i).focus();
                                $('input[name="dynamicFrom"]').eq(i).addClass('focus');
                                break;
                            }
                        }
                    } else if (i > 0) {
                        if (parseInt(tier[i].from) != parseInt(tier[i - 1].to) + 1) {
                            IsdynamicError = 9;
                            $('input[name="dynamicFrom"]').eq(i).focus();
                            $('input[name="dynamicFrom"]').eq(i).addClass('focus');
                            break;
                        }
                    }
                }
                if (IsdynamicError == 2) {
                    this.setState({ error: 'From field required', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 3) {
                    this.setState({ error: 'Floating value not required', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 4) {
                    this.setState({ error: 'To field required', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 5) {
                    this.setState({ error: 'To field should greater than From field in each milestone', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 6) {
                    this.setState({ error: 'Commission field required', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 7) {
                    this.setState({ error: 'Commission should not be more than 10', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 8) {
                    this.setState({ error: 'The last milestone To field should be 999999', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 9) {
                    this.setState({ error: 'The From field should greater the previous To field in each milestone (not including the first)', btnLoader: false });
                    $(e.target).attr("disabled", false);
                    $('.cancel').attr("disabled", false);
                    $('.close-btn').attr("disabled", false);
                } else if (IsdynamicError == 0) {
                    this.save_update_TierCommission(whid, tierJson);
                }
            } else {
                IsdynamicError = 10;
                $('input[name="dynamicFrom"]').eq(0).focus();
                $('input[name="dynamicFrom"]').eq(0).addClass('focus');
                this.setState({ error: 'The lowest value for the From field must be 0', btnLoader: false });
                $(e.target).attr("disabled", false);
                $('.cancel').attr("disabled", false);
                $('.close-btn').attr("disabled", false);
            }
        }
        catch (err) {
            this.setState({ error: 'Error! Please try again.', btnLoader: false });
        }
    }
    save_update_TierCommission(WholesalerId, tierJson) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'tierJson': JSON.stringify(tierJson) },
                body: JSON.stringify({ WholesalerId })
            };
            return fetch(`/api/admin/userCommission_Milestones`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].statusCode == "1") {
                                this.setState({ btnLoader: false, error: apidata[0].statusMessage });
                                setTimeout(() => {
                                    this.handleCancel();
                                }, 5000);
                            } else {
                                this.setState({ error: apidata[0].StatusMessage, btnLoader: false });
                                $('.save').attr("disabled", false);
                                $('.cancel').attr("disabled", false);
                                $('.close-btn').attr("disabled", false);
                            }
                        }
                        else {
                            this.setState({ error:'Error!, Please try again.', btnLoader: false });
                            $('.save').attr("disabled", false);
                            $('.cancel').attr("disabled", false);
                            $('.close-btn').attr("disabled", false);
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error!, Please try again.', btnLoader: false });
                        $('.save').attr("disabled", false);
                        $('.cancel').attr("disabled", false);
                        $('.close-btn').attr("disabled", false);
                    }
                });
        }
        catch (error) {
            this.setState({ error: 'Error!, Please try again.', btnLoader: false });
            $('.save').attr("disabled", false);
            $('.cancel').attr("disabled", false);
            $('.close-btn').attr("disabled", false);
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    getBinTier(WholesalerId){
        this.setState({ loader: true });
        try {
            userService.Bind_Tier_List(WholesalerId).then(
                apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].binDetail.length > 0 && apidata[0].tierDetail.length > 0) {
                                if (this.state.selectedBin != undefined) {
                                    const fromIndex = apidata[0].binDetail.findIndex(x => x.bin === this.state.selectedBin);;
                                    const toIndex = 0;
                                    if (fromIndex == -1) {
                                        apidata[0].binDetail.splice(0, 0, this.state.selectedBin);
                                    } else {
                                        const element = apidata[0].binDetail.splice(fromIndex, 1)[0];
                                        apidata[0].binDetail.splice(toIndex, 0, element);
                                    }
                                }
                                if (this.props.dynamicData[0].isDynamic == true && this.props.dynamicData[0].tierJson != '') {
                                    this.setState({ binData: apidata[0].binDetail, tierDetail: apidata[0].tierDetail, loader: false });
                                } else {
                                    this.setState({ binData: apidata[0].binDetail, tierDetail: apidata[0].tierDetail, tierMilestone: apidata[0].tierDetail, loader: false });
                                }
                            }
                            else {
                                this.setState({ error: 'Opps!, Something went wrong. Try Again.', loader: false });
                            }
                        } else {
                            this.setState({ error: 'Opps!, Something went wrong. Try Again.', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Opps!, Something went wrong. Try Again.', loader: false });
                    }
                }
            );
        }
        catch (error) {
            this.setState({ error: 'Opps!, Something went wrong. Try Again.', loader: false });
        }
    }
    render() {
        const { btnLoader, error, mhError } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div className='popup mfp-zoom-in override-content upcomingDate-popup dynamic-popup'>
                <div className='popup_inner manage-distributor-design'>
                    {this.state.loader &&
                        <div className="theme-loader bonus-loader"></div>
                    }
                    <h1>{this.props.titleText}<button class="close-btn" onClick={this.handleCancel}>X</button></h1>
                    <div className="wholesaler-section">
                        <form className="add-wh-form">
                            <div className="new-section">
                                <div className="new-column">
                                    <div className="same-on">
                                        <label>BIN</label>
                                        <span class="down-arrow"></span>
                                        <select className="form-control" ref={this.bin}>
                                            {
                                                this.state.binData.map((item) => {
                                                    return <option>{item.bin}</option>
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="override-section milestone differ">
                                <div className="right dynamic">
                                    <table id="milestoneTable">
                                        <thead>
                                            <tr className="header Sub">
                                                <th className="first-one">Serial No.</th>
                                                <th className="add-one">Tier Names</th>
                                                <th className="second-one">From</th>
                                                <th className="third-one">To</th>
                                                <th className="fourth-one">Commission</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.tierDetail.length > 0 ?
                                                this.state.tierMilestone.map((data, innerIndex) => {
                                                    return (
                                                        <tr className="milestoneData">
                                                            <td className="first-one">
                                                                <div className="formgroup" key={data.id}>
                                                                    <label>{innerIndex + 1}</label>
                                                                </div>
                                                            </td>
                                                            <td className="add-one">
                                                                <div className="formgroup" key={this.state.tierDetail[innerIndex].tierId}>
                                                                    <input type="text" disabled textindex={innerIndex} defaultValue={this.state.tierDetail[innerIndex].tierName} className="form-control" name="tierName" />
                                                                </div>
                                                            </td>
                                                            <td className="second-one">
                                                                <div className="formgroup" key={data.id}>
                                                                    <input type="number" disabled={disabled} defaultValue={data.from} className="form-control" name="dynamicFrom" />
                                                                </div>
                                                            </td>
                                                            <td className="third-one">
                                                                <div className="formgroup" key={data.id}>
                                                                    <input type="number" disabled={disabled} defaultValue={data.to} className="form-control" name="dynamicTo" />
                                                                </div>
                                                            </td>
                                                            <td className="fourth-one">
                                                                <div className="formgroup" key={data.id}>
                                                                    <input type="number" disabled={disabled} defaultValue={data.commission} className="form-control" name="dynamicComm" />
                                                                </div>
                                                            </td>
                                                        </tr>)
                                                }) : null
                                            }

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="button-section">
                                { btnLoader &&
                                    <div className="theme-loader animated-loader"></div>
                                }
                                <input type="button" disabled={this.state.loader ? true : false} onClick={this.handleSaveSubmit} className={btnLoader ? 'btn save animated-btn' : 'btn save'} value="Save & Submit" />
                                <input type="button" onClick={this.handleCancel} className="btn cancel" value="Cancel" />
                                {error &&
                                    <div className={'alert alert-danger'}>{error}</div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}
export default dynamicCommission;